const noShortKey = ['TypeEvents', 'MediaSources', 'MediaTypes']

export default function (resourceName: string) {
  return !noShortKey.includes(resourceName)
}
